import React from "react";
import CustomIconButton from "../CustomIconButton/CustomIconButton";
import CustomInputAdornment from "../CustomInputAdornment/CustomInputAdornment";
import CustomTextField from "../CustomTextField/CustomTextField";
import { useAsyncDebounce } from "react-table";
import { CustomSearchIcon } from "../CustomIcon/CustomIcon";
import { useStyles } from "../../../assets/jss/PraisoTable";
import { useTranslation } from "react-i18next";
import { getInterpolatedString } from "../../../config/app-global-method";

export const GlobalFilter = ({
  placeholder,
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) => {
  const { i18n, t } = useTranslation();
  const classes = useStyles();
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const [placeholderLabel, setPlaceholderLabel] = React.useState("");
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);
  React.useEffect(() => {
    if (placeholder) {
      const _interpolatedString = getInterpolatedString(placeholder, count);
      setPlaceholderLabel(_interpolatedString);
    }
  }, [placeholder, count]);
  return (
    <CustomTextField
      placeholder={ t("SEARCH")
        /* placeholderLabel && placeholderLabel.length
          ? t(placeholderLabel)
          : i18n.t("SEARCH_FROM", { rowCount: count }) */
      }
      className={classes.search}
      InputProps={{
        endAdornment: (
          <CustomInputAdornment position='start'>
            <CustomIconButton>
              <CustomSearchIcon />
            </CustomIconButton>
          </CustomInputAdornment>
        ),
      }}
      value={value || ""}
      onChange={(e) => {
        setValue(e.target.value);
        onChange(e.target.value);
      }}
    />
  );
};
